// eslint-disable-next-line no-restricted-imports -- This is the one place we must import the MUI TextField component
import MaterialTextField, { type TextFieldProps as MaterialTextFieldProps } from '@mui/material/TextField';
import * as React from 'react';

export type TextFieldProps = Pick<
  MaterialTextFieldProps,
  | 'InputLabelProps'
  | 'InputProps'
  | 'autoComplete'
  | 'autoFocus'
  | 'className'
  | 'defaultValue'
  | 'disabled'
  | 'error'
  | 'fullWidth'
  | 'helperText'
  | 'id'
  | 'label'
  | 'minRows'
  | 'multiline'
  | 'name'
  | 'onBlur'
  | 'onChange'
  | 'onClick'
  | 'onKeyPress'
  | 'onFocus'
  | 'placeholder'
  | 'select'
  | 'size'
  | 'sx'
  | 'type'
  | 'value'
  | 'variant'
> & { inputElementProps?: MaterialTextFieldProps['inputProps']; children?: React.ReactNode };

export const TextField: React.FC<TextFieldProps> = ({
  InputLabelProps,
  InputProps,
  autoComplete,
  autoFocus,
  className,
  defaultValue,
  disabled,
  error,
  fullWidth,
  helperText,
  id,
  inputElementProps,
  label,
  minRows,
  multiline,
  name,
  onBlur,
  onChange,
  onClick,
  onKeyPress,
  onFocus,
  placeholder,
  select,
  size,
  sx,
  type,
  value,
  variant,
  children,
}) => (
  <MaterialTextField
    InputLabelProps={InputLabelProps}
    InputProps={InputProps}
    autoComplete={autoComplete}
    autoFocus={autoFocus}
    className={className}
    defaultValue={defaultValue}
    disabled={disabled}
    error={error}
    fullWidth={fullWidth}
    helperText={helperText}
    id={id}
    // eslint-disable-next-line react/jsx-no-duplicate-props -- inputProps is different from InputProps; need both.
    inputProps={inputElementProps}
    label={label}
    minRows={minRows}
    multiline={multiline}
    name={name}
    onBlur={onBlur}
    onChange={onChange}
    onClick={onClick}
    onKeyPress={onKeyPress}
    onFocus={onFocus}
    placeholder={placeholder}
    select={select}
    size={size ?? 'small'}
    sx={{ margin: 0, ...sx }}
    type={type}
    value={value}
    variant={variant ?? 'outlined'}
  >
    {children}
  </MaterialTextField>
);
